import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import TimeSpend from './time-spend/time-spend'; 
// import HackRecords from './hack-records/hack-records';
import ClickReports from './click-reports/click-reports';
import BreachIncedent from './breach-incedent/breach-incedent';
import RepeatOffender from './repeat-offender/repeat-offender';
import CampaignAnalytics from './campaign-analytics/campaign-analytics';
import IndustryComparison from './industry-comparison/industry-comparison';
import Report from './report';
import ReportEdit from './report-edit';
import DefaultReportPreview from './default-report-preview';
export default class Reports extends Component {
	render() {	
        const { match } = this.props;
		return (
            <Switch>
                <Route path={`${match.path}/analytics`} exact component={ CampaignAnalytics }/>
                <Route path={`${match.path}/breachincident`} exact component={ BreachIncedent }/>
                <Route path={`${match.path}/clickreports`} exact component={ ClickReports }/>
                <Route path={`${match.path}/timespend`} exact component={ TimeSpend }/>
                <Route path={`${match.path}/repeatoffender`} exact component={ RepeatOffender }/>
                <Route path={`${match.path}/industrycomparison`} exact component={ IndustryComparison }/>
                <Route path={`${match.path}`} exact component={ Report }/>
                <Route path={`${match.path}/default/:reportName`} exact component={ DefaultReportPreview }/>
                <Route path={`${match.path}/report/:id`} exact component={ ReportEdit }/>
                <Route render={() => (<Redirect to="/invalid" />)}/>
            </Switch>
		);
	}
}